import { DrawerProps } from "antd";
import { forwardRef, useCallback, useRef } from "react";
import TelaPermissao from "@/Components/Base/Permissao/TelaPermissao";
import TituloAPagarScreen, { ITituloAPagarScreenProps } from "./TItuloAPagarScreen";
import TituloAReceberScreen, { ITituloAReceberScreenProps } from "./TituloAReceberScreen";
import TituloCadastroScreen from "./TituloCadastroScreen";
import DrawerBasic, { IDrawerBasicRef, IDrawerBasicProps } from "@/Components/Base/Drawer/DrawerBasic";
import { EnumTituloTipo } from "@/Models/Financeiro/Titulo/Titulo";
import FaturaFormScreen from "./Fatura/FaturaFormScreen";
import { ITituloFormProps } from "./TituloForm";
import APagarLancamentoForm from "./APagar/lancamento/APagarLancamentoForm";
import { LancamentoType } from "@/Services/Financeiro/Titulo/ParcelaService";
import AReceberLancamentoForm from "./AReceber/lancamento/AReceberLancamentoForm";

interface ITituloFormDrawerProps extends Omit<IDrawerBasicProps, "elementoGatilho"> {
    formProps?:ITituloFormProps;
    acao:"alterar"|"adicionar-receber"|"adicionar-pagar",
    codTituloTipo?:EnumTituloTipo;
    ref?:React.RefObject<IDrawerBasicRef>;
}

const TituloFormDrawer = forwardRef<IDrawerBasicRef, ITituloFormDrawerProps>(function TituloFormDrawer(
    {
        acao, 
        codTituloTipo,
        formProps, 
        width, 
        open, 
        children, 
        destroyOnClose, 
        ...rest
    }, 
    refBase
) {
    width = width ?? "100%";
    codTituloTipo = codTituloTipo ?? EnumTituloTipo.Parcela;

    const refNova = useRef<IDrawerBasicRef>(null);
    const ref = refBase ?? refNova;

    const cancelar = useCallback((e?:React.MouseEvent<HTMLElement, MouseEvent>) => {
        ///@ts-ignore
        ref?.current?.fechar?.(e);
    }, [ref]);
    
    console.log("formProps: ", formProps);
    
    return (
        <DrawerBasic {...rest} ref={ref} elementoGatilho={children} destroyOnClose={destroyOnClose ?? true}>
            {
                codTituloTipo === EnumTituloTipo.Parcela && <>
                    {
                        acao === "alterar" && <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                            <TituloCadastroScreen
                                {...(formProps ?? {})}
                                onCancelar={cancelar}
                            />
                        </TelaPermissao>
                    }
                    {
                        acao === "adicionar-receber" && <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                            <TituloAReceberScreen
                                {...(formProps ?? {})}
                                onCancelar={cancelar}
                                isAReceber={true}
                            />
                            {/* <TituloAReceberScreen
                                {...(formProps ?? {})}
                                onCancelar={cancelar}
                            /> */}
                        </TelaPermissao>
                    }
                    {
                        acao === "adicionar-pagar" && <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                            <TituloAPagarScreen
                                {...(formProps ?? {})}
                                isAReceber={false}
                                onCancelar={cancelar}
                            />
                            {/* <APagarLancamentoForm 
                                onSuccess={() => formProps?.onSalvarSucesso?.(null)}
                                onCancelar={cancelar}
                            /> */}
                        </TelaPermissao>
                    }
                </> || <>
                    {
                        acao === "alterar" && <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                            <FaturaFormScreen
                                codigo={formProps?.codigo}
                                formProps={{
                                    onSucess : formProps?.onSalvarSucesso
                                }}
                            />
                        </TelaPermissao>
                    }
                    {
                        acao === "adicionar-receber" && <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                            <AReceberLancamentoForm
                                onSuccess={(v) => formProps?.onSalvarSucesso?.(v?.titulo?.codigo ?? null)}
                                onCancelar={cancelar}
                                initialValues={formProps?.aPagarProps === undefined ? undefined : {
                                    codCentroCusto : formProps?.aPagarProps?.defaultValues?.rateios?.find?.(Boolean)?.centroCusto?.codigo,
                                    codViagem : formProps?.aPagarProps?.defaultValues?.origem?.codReferencia,
                                    titulo : {
                                        codDevedor : formProps?.aPagarProps?.defaultValues?.codDevedor
                                    }
                                } as any}
                            />
                            {/* <FaturaFormScreen formProps={{ 
                                isAReceber : true, 
                                aReceberProps : formProps?.aReceberProps,
                                onSucess : formProps?.onSalvarSucesso
                            }} /> */}
                        </TelaPermissao>
                    }
                    {
                        acao === "adicionar-pagar" && <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                            <APagarLancamentoForm 
                                onSuccess={(v) => formProps?.onSalvarSucesso?.(v?.titulo?.codigo ?? null)}
                                onCancelar={cancelar}
                                initialValues={formProps?.aPagarProps === undefined ? undefined : {
                                    codCentroCusto : formProps?.aPagarProps?.defaultValues?.rateios?.find?.(Boolean)?.centroCusto?.codigo,
                                    codViagem : formProps?.aPagarProps?.defaultValues?.origem?.codReferencia,
                                    titulo : {
                                        codDevedor : formProps?.aPagarProps?.defaultValues?.codDevedor
                                    }
                                } as any}
                            />
                            {/* <FaturaFormScreen formProps={{ 
                                isAReceber : false, 
                                aPagarProps : formProps?.aPagarProps,
                                onSucess : formProps?.onSalvarSucesso
                            }} /> */}
                        </TelaPermissao>
                    }
                </>
            }
            
        </DrawerBasic>
    );
});

export default TituloFormDrawer;